import React from 'react';
// import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import { useAppSelector } from '../../store/hooks';
// import { ExhibitId } from '../../store/slices/exhibitSlice';
import TcPaper from '../TcPaper';
import TcImage from '../TcImage';
import TcScanQrCodeBar from '../TcScanQrCodeBar';
// import TimeoutScreen from '../exhibits/shared/TimeoutScreen';
// import ExperienceBusy from './shared/ExperienceBusy';
import LoadingScreen from '../shared/LoadingScreen';
import { useSimpleImagePreloader } from '../../hooks/useImagePreloader';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';

import imageBadang00 from '../../assets/images/exhibit/legend-of-badang/img_badang_00.jpg';
import imageBadang01 from '../../assets/images/exhibit/legend-of-badang/img_badang_01.jpg';
import imageBadang02 from '../../assets/images/exhibit/legend-of-badang/img_badang_02.jpg';
import imageBadang03 from '../../assets/images/exhibit/legend-of-badang/img_badang_03.jpg';
import imageBadang04 from '../../assets/images/exhibit/legend-of-badang/img_badang_04.jpg';
import imageBadang05 from '../../assets/images/exhibit/legend-of-badang/img_badang_05.jpg';
import imageBadang06 from '../../assets/images/exhibit/legend-of-badang/img_badang_06.jpg';


export default function Badang() {
    const { t } = useTranslation();
    // const { exhibitId } = useParams<{ exhibitId: string }>();

    // const { hasTimeout, exhibitStatus } = useAppSelector(state => state.exhibit);


    // Device detection
    const { orientation } = useDeviceDetection();
    const isLandscape = orientation === 'landscape';
    
    
    // Preload all images when component mounts
    const allImages = [
        imageBadang00,
        imageBadang01,
        imageBadang02,
        imageBadang03,
        imageBadang04,
        imageBadang05,
        imageBadang06
    ];
    
    const { isLoading, isComplete } = useSimpleImagePreloader(allImages);
    
    // Show loading state while images are being cached
    if (isLoading) {
        return <LoadingScreen message="Loading images..." />;
    }
    
    // Main content screen
    if (isComplete) {
        return (
            <div className={`
                main-content-wrapper bg-black 
                ${isLandscape ? '!pt-8' : '!pt-[112px]'} 
                unselectable 
                has-transition 
            `}>
                <TcPaper classNameStyle="my-2">
                    <h1>{t('exhibits.badang.title')}</h1>
                </TcPaper>
                
                <TcImage classNameStyle="mb-6">
                    <img 
                        src={imageBadang00} 
                        alt={t('exhibits.badang.title')} 
                        className="w-full"
                    />
                </TcImage>
                
                <TcPaper classNameStyle="general-content mb-6">
                    <h2 className="text-3xl mb-4" 
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.title') }}
                    />
                    <p 
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.brief') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang01}
                        alt={t('exhibits.badang.story.subtitle1')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content mb-6">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle1') }}
                    />
                    <p 
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph1') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang02}
                        alt={t('exhibits.badang.story.subtitle2')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content mb-6">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle2') }}
                    />
                    <p 
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph2') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang03}
                        alt={t('exhibits.badang.story.subtitle3')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content mb-6">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle3') }}
                    />
                    <p
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph3') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang04}
                        alt={t('exhibits.badang.story.subtitle4')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content mb-6">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle4') }}
                    />
                    <p
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph4') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang05}
                        alt={t('exhibits.badang.story.subtitle5')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content mb-6">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle5') }}
                    />
                    <p
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph5') }}
                    />
                </TcPaper>

                <TcImage classNameStyle="mb-6">
                    <img
                        src={imageBadang06}
                        alt={t('exhibits.badang.story.subtitle6')}
                        className="w-full"
                    />
                </TcImage>

                <TcPaper classNameStyle="general-content">
                    <h3 className="text-2xl mb-2"
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.subtitle6') }}
                    />
                    <p
                        dangerouslySetInnerHTML={{ __html: t('exhibits.badang.story.paragraph6') }}
                    />
                </TcPaper>

                <TcScanQrCodeBar classNameStyle="fixed bottom-0 left-0 right-0" />

                {/* {hasTimeout && <TimeoutScreen />}
                {exhibitStatus[exhibitId as ExhibitId] === 'busy' && <ExperienceBusy />} */}
            </div>
        );
    }
    
    // Fallback loading screen
    return <LoadingScreen message="Loading..." />;
} 